<template>
  <div class="np-utr-root" :class="{ shake: isShaking }" ref="bk" id="bkT">
    <div class="np-utr-card">
      <van-field
        v-model="state.refNo"
        type="digit"
        :formatter="formatter"
        maxlength="12"
        :placeholder="state.utrText"
        class="np-utr-field"
        @blur="addShake"
        @click-input="clickIpt"
      >
        <template #label>
          <span class="np-utr-label">UTR</span>
        </template>
      </van-field>
      <p v-if="state.refNo && state.refNo.length < 12" class="np-utr-hint">
        Please enter 12 digits
      </p>
    </div>

    <div :class="['np-utr-actions', embedded ? '' : 'is-fixed']">
      <van-button block type="primary" class="np-btn-primary" :loading="subLoading"
        loading-text="Loading..." @click="subOrder">Submit UTR</van-button>
      <p class="np-utr-note">Secure verification</p>
    </div>

    <div v-if="showDialog" class="np-dialog-overlay">
      <div class="np-dialog">
        <h2 class="np-dialog-title">Wait payment response</h2>
        <div class="np-dialog-spinner" aria-hidden="true"></div>
        <p class="np-dialog-content">
          If you have not received a response within 15 minutes after completing
          this payment, you can submit your UTR on this page. We will check your
          payment status.
        </p>
        <div class="np-dialog-actions">
          <button type="button" class="np-dialog-btn" @click="onDialogConfirm">
            Give up waiting
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast } from "vant";
import Axios from "@/axios";
import { Util } from "@/common/js/utils.js";
import { decrypt } from "@/common/js/utils.js";

const route = useRoute();
const router = useRouter();
const subLoading = ref(false);
const isShaking = ref(false);
const showDialog = ref(false);

const props = defineProps({
  showArrow: { type: Number, default: 0 },
  embedded: { type: Boolean, default: false },
});

let state = reactive({
  id: route.query.id,
  refNo: "",
  utrText: "12-digit UTR",
});

let queryInterval = null;

onMounted(() => {
  if (!props.embedded) {
    document.title = "deposit";
  }
  if (queryInterval) {
    clearInterval(queryInterval);
    queryInterval = null;
  }
  if (props.showArrow === 1) {
    isShaking.value = true;
  } else if (!props.embedded) {
    setTimeout(() => { isShaking.value = true; }, 6000);
  }
});

const formatter = (v) => (v || "").replace(/\D/g, "");

const addShake = () => {
  const bk = document.getElementById("bkT");
  bk && bk.classList.add("shake");
  state.utrText = "12-digit UTR";
};

const clickIpt = () => {
  const bk = document.getElementById("bkT");
  bk && bk.classList.remove("shake");
  state.utrText = "";
};

const closeModal = () => { state.refNo = ""; };

const subOrder = async () => {
  if (!state.refNo) return;
  if (!/^\d{12}$/.test(state.refNo)) {
    return Toast({ message: "UTR must be a 12-digit number", duration: 2000 });
  }
  if (subLoading.value) return;
  subLoading.value = true;
  try {
    let res = await Axios("post", "/safe/submit/utr", { id: state.id, utr: state.refNo });
    if (res.code === 200) {
      openDialog();
      window.globalUtrData = { subTime: Util.filterTimes(new Date()), utr: state.refNo };
    } else {
      Toast({ message: res.msg, duration: 2000 });
    }
    subLoading.value = false;
  } catch (error) {
    subLoading.value = false;
  }
};

const onDialogConfirm = async () => { closeDialog(); };

const openDialog = () => {
  showDialog.value = true;
  if (queryInterval) { clearInterval(queryInterval); queryInterval = null; }
  queryInterval = setInterval(() => { queryOrder(); }, 3000);
};

const closeDialog = () => {
  showDialog.value = false;
  state.refNo = "";
  if (queryInterval) { clearInterval(queryInterval); queryInterval = null; }
};

const queryOrder = async () => {
  try {
    let res = await Axios("post", "/safe/query", { id: state.id });
    if (res.code === 200) {
      res.result = JSON.parse(decrypt(res.result, state.id));
      if ([1].includes(res.result.status)) {
        closeDialog();
        router.push(`/checkout?id=${state.id}&type=success`);
      }
    } else if (res.code !== 200) {
      router.push(`/expired`);
    }
  } catch (error) {
    console.error("Error in queryOrder:", error);
  }
};

defineExpose({ closeModal });

onUnmounted(() => {
  if (queryInterval) { clearInterval(queryInterval); queryInterval = null; }
});
</script>

<style scoped lang="less">
.np-utr-root { width: 100%; }
.np-utr-root.shake { animation: np-shake 0.45s ease; }
.np-utr-label { font-weight: 600; color: var(--np-text-secondary); }
.np-dialog-spinner {
  width: 40px; height: 40px; margin: 16px auto 0;
  border: 3px solid var(--np-bg-primary-soft);
  border-top-color: var(--np-primary);
  border-radius: 50%;
  animation: np-spin 0.8s linear infinite;
}
</style>
